import React, { useContext, useEffect, useRef, useState } from "react";
import {
  activateViewport,
  getCurrentImage,
  getInitialZoom,
  getViewport,
  loadActiveViewport,
  setInvert,
  FlipHorizontally,
  FlipVertically,
  setToolOnActiveViewport,
  updateViewport,
  checkForLateralSeries,
  changeStack,
  updateOrientationMarkers,
  toggleReferenceLines,
  loadHeatMap,
  loadOutline,
  resizeViewport,
  setRotation,
  applyViewportStates,
  setStackPosition,
  getMPRViewport,
  rerenderViewport,
  resetViewPlaneOfCamera,
  performResize,
  resetRotation,
  resetStackPosition
} from "../../helpers/CornerstoneViewportService";
import $ from "jquery";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import ImageScrollbar from "../Scrollbar/ImageScrollbar";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import SaveAsScDicomButton from  "../Tools/SaveAsScDicomButton";
import ScDicomCopyToClipboardButton from "../Tools/ScDicomCopyToClipboardButton";
import {
  DEFAULT_TOOL,
  HP_VIEWPORT_FLIP,
  LATERAL_VIEW_MODALITY_LIST,
  NONXRAYMODALITIES,
  TOAST_TYPE,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import PatientDetails from "../Overlays/PatientDetails";
import StudyDetails from "../Overlays/StudyDetails";
import SeriesDetails from "../Overlays/SeriesDetails";
import DICOMDetails from "../Overlays/DICOMDetails";
import SCDICOMDetails from "../Overlays/SCDICOMDetails";
import StudyClippingDetails from "../Overlays/StudyClippingDetails";
import {
  Enums,
  utilities,
} from "@cornerstonejs/core";
import {
  StackScrollTool,
  Enums as e,
  annotation
} from "@cornerstonejs/tools";
import MarkWarning from "../Overlays/MarkWarning/MarkWarning";
import {
  resetVOILUTRange,
  setVOILUTRange,
} from "../../helpers/WindowLevelUtility";
import { useTranslation } from "react-i18next";
import OrientationMarkers from "../Overlays/OrientationMarkers";
import TopLoader from "../../../../components/TopLoadingBar/TopLoader";
import loaderContext from "../../../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import { generateSRReport } from "../../helpers/SRModalityService";
import {
  cine
} from "@cornerstonejs/tools/utilities";
import CINEMinus from "../../../../components/SVGComponents/Tools/CINEMinus";
import CINEPlus from "../../../../components/SVGComponents/Tools/CINEPlus";
import CINEPlaySmall from "../../../../components/SVGComponents/Tools/CINEPlaySmall";
import CINEPauseSmall from "../../../../components/SVGComponents/Tools/CINEPauseSmall";
import Impression from "../../../../components/SVGComponents/Tools/Impression";
import themeContext from "../../../../context/theme/ThemeContext";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../helpers/StackScrollSyncService";
import { isKeyImageAlreadyPresent } from "../../helpers/KeyImageUtility";
import {
  forceReinferenceImage,
  logViewOriginalImage,
} from "../../../../service/StudyViewerService";
import MobileOverlay from "../Overlays/MobileOverlay";
import Draggable from "react-draggable";
import Copy from "../../../../components/SVGComponents/Copy";
import toastContext from "../../../../context/toast/ToastContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { isSeriesValid } from "../../helpers/ViewerHelperService";
import VDCMobileDetails from "../Overlays/VDCMobileDetails";
import { getToolGroupManager } from "../../helpers/CornerstoneService";
import * as cornerstonetools from "@cornerstonejs/tools";
import Spinner from "../../../../components/Spinner/Spinner";
import { isNonFrontalImagePresent } from "../../helpers/NonFrontalUtility";
import { prefetchData } from "../../helpers/CornerstoneThumbnailService";
import { uploadScDicom, submitStudyClipping } from '../../../../service/StudyViewerService';
import { eventTarget } from "@cornerstonejs/core";
import StudyMaskingProfile from "../Overlays/StudyMaskingProfile";
import userContext from "../../../../context/users/UserContext";
import MaskImage from "../Overlays/MaskImage/MaskImage";
import { isChestXrayStudy } from "../../../../helpers/CommonUtility";

const Viewport = ({ viewportIndex, priors,setInitialVOI }) => {
  const { t } = useTranslation();
  const [viewportElement, setViewportElement] = useState(null);
  const [viewportModality, setViewportModality] = useState("");
  const [viewportProgress, setViewportProgress] = useState(0);
  const [viewportProgressComplete, setViewportProgressComplete] =
    useState(true);
  const [overlayPatientData, setOverlayPatientData] = useState({});
  const [overlayStudyData, setOverlayStudyData] = useState({});
  const [impressionHover, setImpressionHover] = useState(false);
  const [showKeyImageStar, setShowKeyImageStar] = useState(false);
  const {
    studyData,
    studyModality,
    viewportLoading,
    setViewportLoading,
    progress,
    setProgress,
    setProgressComplete,
    impressions,
    keyImages,
    priorStudyKeyImages,
    enableHeatmap,
    enableOutline,
    studyParentId,
    priorStudyData,
    studyBoundingBox,
    setAllLoadingComplete,
    sharedViewer,
    nonFrontalImages,
    setForceReinferenceImageIds,
    isHeatMapEnabled,
    setIsHeatMapEnabled,
    isOutlineEnabled,
    setIsOutlineEnabled,
    hpLoading, setHpLoading,
    showPathologyOptions,
    setShowPathologyOptions,
    setViewerOpacity,
    setShowTopBar,
    setShowSharedTopBar,
    hpDataList,
    isHPApplied,
    hpNotFound,
    
    setMaskImages,
    maskImages
  } = useContext(studyviewerContext);
  const [viewportLoaded, setViewportLoaded] = useState(false);

  const [hpSeriesDataLoaded, setHPSeriesDataLoaded] = useState(false);
  const {
    activeViewportIndex,
    changeActiveViewportIndex,
    viewportSeriesData,
    changeViewportSeriesData,
    viewportRow,
    viewportColumn,
    addViewportElement,
    viewportElements,
    activeTool,
    previousActiveTool,
    showOverlay,
    setActiveTool,
    setPreviousActiveTool,
    setViewportRow,
    setViewportColumn,
    contextMenuOpen,
    setContextMenuOpen,
    originalImageActiveState,
    editWarning,
    setEditWarning,
    isCineEnabled,
    setIsCineEnabled,
    isSynchronizedEnabled,
    isMPRActive,
    dragEvent,
    setDragEvent,
    activeViewportModality,
    setActiveViewportModality,
    isCompareActive,
    showCompare,
    setShowCompare,
    isReferenceLinesEnabled,
    setIsReferenceLinesEnabled,
    disableAddPathology,
    setDisableAddPathology,
    setAllowAddingTextAnnotation,
    setOriginalImageActiveState,
    isReferenceLineActivated,
    setIsReferenceLineActivated,
    setImageLoadedOnViewport,
    updateBBPosition,
    setViewportLoadingComplete,
    handleDefaultToolChange,
    isScrollingUp,
    setIsScrollingUp,
    viewportHpLayout,
    viewportHpImage,
    viewportOldState,
    setViewportOldState,
    updateViewportProperties,
    viewportStates,
    viewportDoubleClickIndex, setViewportDoubleClickIndex,
    viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst,
    handleRemoveWarning,
    handleRemoveMaskWarning,
    boundingBoxAdding, setBoundingBoxAdding,
    isSrSelected, setIsSrSelected, 
    addBlackMaskOverlayOnViewport, isCreatingMaskingProfile, maskingBoxAdding, setMaskingBoxAdding,
    isCropEnable, maskingConfirm, setMaskingConfirm,
    disableMasking
  } = useContext(ViewportContext);

  const {
    activeThumbnailIndex,
    changeActiveThumbnailIndex,
    activeThumbnailData,
    lateralThumbnailIndex,
    activeModality,
    setActiveModality,
    setActiveStudyId,
    thumbnailLoadingComplete,
    setLateralThumbnailIndex,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);

  const { setAlertSuccessModal, 
    alertSuccessModal, 
    setForReinferenceInProgress, 
    reportDoneStatusState,
    setReportMenu,
    setSeriesMenu,
    reportMenu,
    seriesMenu,
    usgAgentEnabled, reportingDoctorName, isWordFilePath ,
    handleDSRRegenerate,
    inputValue,
    setInputValue,
    studyDescription
  } = useContext(studyReportContext);

  const {enableLlmReport} = useContext(userContext);
  const { theme } = useContext(themeContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [srReport, setSRReport] = useState("");
  const [imageCount, setImageCount] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewportData, setViewportData] = useState(activeThumbnailData);
  const [thumbnailId, setThumbnailId] = useState();
  const [voi, setVOI] = useState({ windowCenter: null, windowWidth: null });
  const [scale, setScale] = useState(1);
  const [initialVOIRange, setInitialVOIRange] = useState({});
  const [markers, setMarkers] = useState({});
  const elementRef = useRef(null);
  const impressionRef = useRef(null);
  const [scrollbarHeight, setScrollbarHeight] = useState("100px");
  const [cINEFramesPerSecond, setCINEFramesPerSecond] = useState(7);
  const [isActivated, setIsActivated] = useState(false);
  const [viewportLevelCINEEnabled, setViewportLevelCINEEnabled] =
    useState(true);
  const [viewportRendered, setViewportRendered] = useState(false);
  const { showToastv2 } = useContext(toastContext);
  const [viewportLoaderRunning, setViewportLoaderRunning] = useState(true);
  const [showForceReinference, setShowForceReinference] = useState(false);
  const [nonFrontalImageId, setNonFrontalImageId] = useState(null);
  const [viewportFocusCalled, setViewportFocusCalled] = useState(false);
  const {roles, username, userId} = useContext(userContext);

  const [clippedStudyImages, setClippedStudyImages] = useState([]);
  const viewportRef = useRef(null);
  const rightClickTimer = useRef(null);
  const isDragging = useRef(false);
  const rightClickThreshold = 400; 

  const updateKeyImageStar = async () => {
    const viewport = await getViewport(viewportIndex);
    if (
      viewport &&
      viewport.imageIds.length != 0 &&
      (isKeyImageAlreadyPresent(viewport, keyImages) ||
        (priors && isKeyImageAlreadyPresent(viewport, priorStudyKeyImages)))
    ) {
      setShowKeyImageStar(true);
    } else {
      setShowKeyImageStar(false);
    }
  };

  const updateNonFrontalButton = async () => {
    const viewport = await getViewport(viewportIndex);

    if (viewport && viewport.imageIds.length != 0) {
      if (
        isNonFrontalImagePresent(
          viewport,
          nonFrontalImages,
          setNonFrontalImageId
        )
      ) {
        setShowForceReinference(true);
      } else {
        setShowForceReinference(false);
      }
    }
  };

  useEffect(() => {
    if (viewportLoaded) {
      updateKeyImageStar();
    }
  }, [keyImages, viewportLoaded]);

  const updateForceReinferenceImageIds = (nonFrontalImages) => {
    const foundObject = nonFrontalImages.find(obj => obj.imageId === nonFrontalImageId);
      if (foundObject) {
        const imageUrl = foundObject.imageUrl;
        setForceReinferenceImageIds(prevState => [...prevState, imageUrl]);
      }
  }

  const forceReinference = async () => {
    const response = await forceReinferenceImage(
      studyParentId,
      nonFrontalImageId
    );
    if (response.status === 200) {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = true;
        newItem.isWarning = false;
        newItem.description = t("viewer.tools.force-reinference-success");
        return newItem;
      });
    } else {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = false;
        newItem.description = response.data.message;
        return newItem;
      });
    }
  };



    
 

    const openReportMenu = () => {
      setViewerOpacity(0);
      setTimeout(() => {
        setReportMenu(true);
        setSeriesMenu(false);
      }, 100);
      setTimeout(async () => {
        await performResize();
        setViewerOpacity(1);
      }, 1000); 
    
    };

  useEffect(() => {
    if (viewportIndex !== 0) return;
    if (
      activeViewportIndex / VIEWPORT_COLUMN >= viewportRow ||
      activeViewportIndex % VIEWPORT_COLUMN >= viewportColumn
    ) {
      setActive();
    }
  }, [viewportColumn, viewportRow]);

  useEffect(() => {
    const getOrientationMarkers = async (event) => {
      const m = await updateOrientationMarkers(
        event,
        "viewport_" + viewportIndex
      );
      setMarkers(m);
      // updateKeyImageStar();
      updateNonFrontalButton();

      const viewport = await getViewport(viewportIndex);
      setCurrentImage(viewport.getCurrentImageIdIndex());

      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex !== null &&
        isReferenceLineActivated
      ) {
        setIsReferenceLinesEnabled(true);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_NEW_IMAGE,
        getOrientationMarkers
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_NEW_IMAGE,
          getOrientationMarkers
        );
      };
    }
  }, [viewportElement, nonFrontalImages]);

  useEffect(() => {
    const updateImageIndex = async () => {
      const viewport = await getViewport(viewportIndex);
      setCurrentImage(viewport.getCurrentImageIdIndex());
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_VIEWPORT_SCROLL,
        updateImageIndex
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_VIEWPORT_SCROLL,
          updateImageIndex
        );
      };
    }
  }, [viewportElement]);


   
  const loadAIOutlineAndHeatmap = async () => {
    if (!isHeatMapEnabled && !isOutlineEnabled)
      return;
    if (priors) {
      if (
        isHeatMapEnabled &&
        activeViewportIndex === viewportIndex &&
        NONXRAYMODALITIES.includes(activeModality)
      ) {
        // await resizeViewport();
           await rerenderViewport();
        loadHeatMap(
          viewportSeriesData[viewportIndex]?.heatmapStack?.imageIds,
          isHeatMapEnabled,
          activeViewportIndex
        );
      }
      if (
        isOutlineEnabled &&
        activeViewportIndex === viewportIndex &&
        NONXRAYMODALITIES.includes(activeModality)
      ) {
        // await resizeViewport();
        await rerenderViewport();
        loadOutline(
          viewportSeriesData[viewportIndex]?.outlineStack?.imageIds,
          isOutlineEnabled,
          activeViewportIndex
        );
      }
      return;
    }

    if (isHeatMapEnabled && activeViewportIndex === viewportIndex) {
      // await resizeViewport();
      await rerenderViewport();
      loadHeatMap(
        studyData.heatmapStacks[activeThumbnailIndex]?.imageIds,
        isHeatMapEnabled,
        activeViewportIndex
      );
    }
    if (isOutlineEnabled && activeViewportIndex === viewportIndex) {
      // await resizeViewport();
      await rerenderViewport();
      loadOutline(
        studyData.outlineStacks[activeThumbnailIndex]?.imageIds,
        isOutlineEnabled,
        activeViewportIndex
      );
    }
  };

  useEffect(() => {
    const enableReferenceLine = async (event) => {
      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex != null &&
        isReferenceLineActivated
      ) {
        setTimeout(() => {
          setIsReferenceLinesEnabled(true);
        }, 1000);
      }
    };

    if (
      viewportElement !== null &&
      viewportIndex == 1 &&
      !isReferenceLinesEnabled
    ) {
      viewportElement?.addEventListener(
        Enums.Events.IMAGE_RENDERED,
        enableReferenceLine
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.IMAGE_RENDERED,
          enableReferenceLine
        );
      };
    }
  }, [viewportElement]);




  // useEffect(() => {
  //   const stopLoader = async (event) => {
  //     console.log("IMAGE RENDERED");
  //     console.log(event);
  //     if (event.detail.viewportStatus === "rendered") {
  //       setViewportLoaderRunning(false);
  //     }
  //   };

  //   if (viewportElement !== null) {
  //     viewportElement?.addEventListener(
  //       Enums.Events.IMAGE_RENDERED,
  //       stopLoader
  //     );

  //     return () => {
  //       viewportElement?.removeEventListener(
  //         Enums.Events.IMAGE_RENDERED,
  //         stopLoader
  //       );
  //     };
  //   }
  // }, [viewportElement]);

  useEffect(() => {
    loadAIOutlineAndHeatmap();
 //   addBlackMaskOverlayOnViewport();
  }, [currentImage, isHeatMapEnabled, isOutlineEnabled]);

  // useEffect(() => {
  //   if (viewportLoading.viewport1Loading) {
  //     updateBBPosition(studyBoundingBox);
  //   }
  // }, [activeViewportIndex, currentImage, viewportLoading]);

  const handleShowOriginalToggle = async () => {
    if (activeViewportIndex === viewportIndex) {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await changeStack(
        activeViewportIndex,
        thumbnailId,
        viewportSeriesData[activeViewportIndex].stack,
        viewportSeriesData[activeViewportIndex].originalStack,
        originalImageActiveState[viewportIndex],
        currentImage,
        setLoaderRunning,
        ref
      );
      setTimeout(() => {
        ref.current.complete();
      }, 500);
      if (originalImageActiveState[viewportIndex]) {
        logViewOriginalImage(studyParentId);
      }
    }
  };

  useEffect(() => {
    if (viewportRendered) {
      handleShowOriginalToggle();
    }
  }, [originalImageActiveState]);

  const enableViewportElement = async () => {
    setViewportLoaderRunning(false);
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    addViewportElement(element);
    setViewportElement(element);
    activateViewport(element, viewportIndex);
    setViewportModality(activeModality);
    setActiveViewportModality(activeModality);
    setIsActivated(true);
    // if (viewportIndex !== 0) {
    //   setViewportLoaderRunning(false);
    // }
  };

  useEffect(() => {
    enableViewportElement();
  }, []);

  const loadLateralSeriesInViewport = async () => {
    setViewportLoaderRunning(true);
    const toolGroup = await getToolGroupManager(
      process.env.REACT_APP_TOOL_GROUP_ID
    );
    toolGroup.addTool(cornerstonetools.ReferenceLinesTool.toolName);
    setIsReferenceLineActivated(true);
    setThumbnailId(lateralThumbnailIndex);
    setViewportLoaded(true);
    await loadViewport(lateralThumbnailIndex, viewportIndex);
    setIsReferenceLinesEnabled(true);
    await updateVoiForTheVeryFirstTimeForLateralSeries();
    setAllLoadingComplete(true);
  };

  const updateVoiForTheVeryFirstTimeForLateralSeries = async () => {
    const viewport = await getViewport(1);
    setVOI({
      windowCenter: Math.trunc(viewport.csImage.windowCenter),
      windowWidth: Math.trunc(viewport.csImage.windowWidth),
    });
  };

  useEffect(() => {
    if (
      lateralThumbnailIndex !== null &&
      lateralThumbnailIndex !== undefined &&
      viewportIndex === 1
    ) {
      loadLateralSeriesInViewport();
    }
  }, [lateralThumbnailIndex]);

  const getLateralSeriesIndex = async () => {
    let index = await checkForLateralSeries();
    if (index !== -1) {
      setLateralThumbnailIndex(index);
    }
  };

  useEffect(() => {
    if (thumbnailLoadingComplete && !isMobile && (hpDataList == undefined || Object.keys(hpDataList).length === 0)) {
      getLateralSeriesIndex();
    }
  }, [thumbnailLoadingComplete]);

  useEffect(() => {
    if (viewportIndex === activeViewportIndex) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [isReferenceLinesEnabled]);

  useEffect(() => {
    if (isReferenceLinesEnabled) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [activeViewportIndex]);

  const updateInitialVOI = async () => {
    const viewport = await getViewport(viewportIndex);
    setVOI({
      windowCenter: viewport?.csImage?.windowCenter,
      windowWidth: viewport?.csImage?.windowWidth,
    });
  };

  const loadViewport = async (thumbnailIndex, viewportIndex) => {
    setViewportLoaderRunning(true);
    setViewportLoading(() => {
      const newVal = { ...viewportLoading };
      if (viewportIndex == 0) {
        newVal.viewport1Loading = false;
      } else if (viewportIndex == 1) {
        newVal.viewport2Loading = false;
      } else if (viewportIndex == 2) {
        newVal.viewport3Loading = false;
      } else {
        newVal.viewport4Loading = false;
      }

      return newVal;
    });
    const maxImageCount = await loadActiveViewport(
      thumbnailIndex,
      viewportIndex,
      setScale,
      setInitialVOIRange,
      setInitialVOI,
      isScrollingUp,
      setCurrentImage,
      currentImage,
      loadAIOutlineAndHeatmap,
      hpLoading ? viewportHpImage?.get(viewportIndex) : 0,
    );
    if(isScrollingUp){
      setIsScrollingUp(false);
    }
    if (viewportIndex === 0 || hpLoading) setImageLoadedOnViewport(true);
    setAllowAddingTextAnnotation(true);
    setViewportRendered(true);
    setTimeout(() => {
      setViewportLoading(() => {
        const newVal = { ...viewportLoading };
        if (viewportIndex == 0) {
          newVal.viewport1Loading = true;
        } else if (viewportIndex == 1) {
          newVal.viewport2Loading = true;
        } else if (viewportIndex == 2) {
          newVal.viewport3Loading = true;
        } else {
          newVal.viewport4Loading = true;
        }

        return newVal;
      });
    }, 1000);
    setImageCount(maxImageCount);
    if (
      !LATERAL_VIEW_MODALITY_LIST.includes(studyModality) ||
      isMobile ||
      sharedViewer
    ) {
      setLoaderRunning(false);

    }
    updateInitialVOI();
    setAllLoadingComplete(true);
    setViewportLoaderRunning(false);
  };

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  const handleLoadSecondTime = async () => {   
    if (viewportSeriesData[viewportIndex].stack != "" && !hpLoading) {
      // if (isMobile) {
      //   enableViewportElement();
      // }
      setViewportLoaderRunning(true);
      setViewportProgressComplete(false);
      setViewportProgress(20);
      if (activeModality === "SR") {
        generateSRReport(
          viewportSeriesData[viewportIndex].stack.thumbnailImageIds[0],
          setSRReport
        );
        setTimeout(() => {
          setViewportLoaderRunning(false);
        }, 1000);
        return;
      }
      setViewportLoaded(true);
      await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);
      setViewportProgress(100);
      if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
      if (isMobile) {
        setViewportLoaderRunning(false);
      }
      if (viewportIndex === 0) setViewportLoadingComplete(true);
      // resizeViewport();
      rerenderViewport();
    }
  };

  useEffect(() => {

    const handleThumbnailClick = async () => {
      console.log("viewport port series data", viewportSeriesData);
      if (
        viewportIndex === activeViewportIndex &&
        viewportSeriesData[viewportIndex].stack != "" && !hpLoading &&
        activeThumbnailIndex !== undefined
      ) {
        // if (isMobile) {
        //   enableViewportElement();
        // }
        setViewportLoaderRunning(true);
        setViewportProgressComplete(false);
        setViewportProgress(20);
        setViewportModality(activeModality);
        setActiveViewportModality(activeModality);
        if (activeModality === "SR") {
          generateSRReport(
            viewportSeriesData[viewportIndex].stack.thumbnailImageIds[0],
            setSRReport
          );
          setTimeout(() => {
            setViewportLoaderRunning(false);
            setIsSrSelected(true);
            if (viewportIndex === 0) setImageLoadedOnViewport(true);
          }, 1000);
          return;
        }
        setViewportLoaded(true);
        setThumbnailId(activeThumbnailIndex);
        await loadViewport(activeThumbnailIndex, activeViewportIndex);
        setViewportProgress(100);
        // setCurrentImage(0);
        setViewportData(activeThumbnailData);
        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        if (isMobile) {
          setViewportLoaderRunning(false);
        }
        if (viewportIndex === 0) setViewportLoadingComplete(true);
        
        // await resetViewPlaneOfCamera(viewportIndex);
        // resizeViewport();
        // setTimeout(() => {
          resetRotation(viewportIndex);
          resetStackPosition(viewportIndex);
        // }, 200);
      }
    };
    if (!dragEvent) {
      handleThumbnailClick();
    }
  }, [viewportSeriesData]);


  useEffect(() =>{
    if(hpLoading){
      setLoaderRunning(true);
      ref.current.continuousStart();
    }
  },[hpLoading])

  useEffect(() => {
    const handleHPLoading = async () => {
      if (
        hpLoading &&
        viewportSeriesData[viewportIndex].stack != ""
      ) {
        setViewportLoaderRunning(true);

        const firstValidIndex = viewportSeriesData.findIndex(
          (v) => v.stack !== ""
        );
        
        if(firstValidIndex === viewportIndex){
          setActiveModality(viewportSeriesData[viewportIndex].modality);
          changeActiveThumbnailIndex(viewportSeriesData[viewportIndex].thumbnailIndex);
          setActiveViewportModality(viewportModality);
          changeActiveViewportIndex(viewportIndex);
          let studyIdString = viewportSeriesData[viewportIndex].study;
          let studyIdInteger = parseInt(studyIdString, 10);
          setActiveStudyId(studyIdInteger);
        }
        setViewportModality(viewportSeriesData[viewportIndex].modality);
        if (viewportSeriesData[viewportIndex].modality === "SR") {
          generateSRReport(
            viewportSeriesData[viewportIndex].stack.thumbnailImageIds[0],
            setSRReport
          );
          return;
        }
        await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);
        
        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        setViewportLoaded(true);  
        setHPSeriesDataLoaded(true);
        setViewportLoadingComplete(true);
      }
    };
    if (!dragEvent) {
        handleHPLoading();
    }
  }, [viewportSeriesData, hpLoading]);

  const applyViewportLayout = (viewportIndex) => {
    const layout = viewportHpLayout.get(viewportIndex);
    if (!layout) return;

    
    if (layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE) {
      FlipHorizontally(viewportIndex);
    }
    
    if (layout.flipVertically === HP_VIEWPORT_FLIP.ENABLE) {
      FlipVertically(viewportIndex);
    }
    if(layout.windowWidth && layout.windowLevel) {
      setVOILUTRange(viewportIndex, layout.windowWidth, layout.windowLevel);
    }
    
    setStackPosition(viewportIndex, layout.alignment, layout.rotation, layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE);
    setTimeout(() => {
      setRotation(viewportIndex, layout.rotation);
    }, 200);

    const lastValidViewportIndex = viewportSeriesData.findLastIndex(
      (viewport) => viewport.stack !== ""
    );
    setTimeout(() => {
      if(lastValidViewportIndex == viewportIndex){
        resizeViewport();
        setActiveTool(cornerstonetools.WindowLevelTool.toolName);
        setHpLoading(false);
        ref.current.complete();
      }
    }, 600);
  };


  // const setHpCurrentImage = () => {
  //   startPrefetching();
  //   setViewportLoaderRunning(false);
  //     const imageIndex = viewportHpImage.get(viewportIndex); 
  //     if(imageIndex){
  //       setCurrentImage(imageIndex);
  //       setImageIndex(viewportIndex, imageIndex);
  //     }
  //     const lastValidViewportIndex = viewportSeriesData.findLastIndex(
  //       (viewport) => viewport.stack !== ""
  //     );
  //     setTimeout(() => {
  //       if(lastValidViewportIndex == viewportIndex){
  //         resizeViewport();
  //         setHpLoading(false);
  //         ref.current.complete();
  //       }
  //     }, 500);
  // };

  useEffect(() => {
    if(viewportHpLayout && viewportHpLayout.size > 0 && hpLoading && viewportLoaded && hpSeriesDataLoaded){
      // setTimeout(() => applyViewportLayout(viewportIndex), 1000);
      applyViewportLayout(viewportIndex);
      // setHpCurrentImage();
    }
  }, [viewportHpLayout, hpLoading, viewportLoaded, hpSeriesDataLoaded]);
   
  //start stop prefetch
  const startPrefetching = async () => {
    if (viewportModality != "SR") {
      await prefetchData(viewportSeriesData[viewportIndex].thumbnailIndex);
    }
  };

  const onChange = (event) => {
    const intValue = parseInt(event.target.value, 10);
    updateViewport(viewportIndex, intValue);
  };

  const playCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.playClip(element, { framesPerSecond: cINEFramesPerSecond });
  };

  const pauseCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.stopClip(element);
  };

  useEffect(() => {
    if (activeViewportIndex === viewportIndex) {
      if (isCineEnabled) {
        if (viewportLevelCINEEnabled) {
          playCINE();
        } else {
          pauseCINE();
        }
      } else {
        setViewportLevelCINEEnabled(true);
        pauseCINE();
      }
    } else {
      if (viewportLevelCINEEnabled) {
        pauseCINE();
        setViewportLevelCINEEnabled(true);
      }
    }
  }, [
    activeViewportIndex,
    isCineEnabled,
    cINEFramesPerSecond,
    viewportLevelCINEEnabled,
  ]);

  useEffect(() => {
    setViewportLevelCINEEnabled(false);
  }, [activeThumbnailIndex]);

  // const onKeyPress = async (event) => {
  //   const keyCode = event.which;

  //   switch (keyCode) {

  //     case 27: //ESC
  //       if (activeTool === DEFAULT_TOOL) {
  //         break;
  //       }
  //       setPreviousActiveTool(activeTool);
  //       // setActiveTool(DEFAULT_TOOL);
  //       handleDefaultToolChange();
  //       break;
  //     case 73: //i -- INVERT
  //       setInvert(activeViewportIndex);
  //       break;
  //     case 72: //h -- HORIZONTAL FLIP
  //       FlipHorizontally(activeViewportIndex);
  //       break;
  //     case 86: //v -- VERTICAL FLIP
  //       FlipVertically(activeViewportIndex);
  //       break;
  //     case 48: //NORMAL WW WC
  //       resetVOILUTRange(activeViewportIndex, initialVOIRange);
  //       break;
  //     case 49: //CT ABDOMEN
  //       setVOILUTRange(activeViewportIndex, 400, 60);
  //       break;
  //     case 50: //CT ANGIO
  //       setVOILUTRange(activeViewportIndex, 600, 300);
  //       break;
  //     case 51: //CT BONE
  //       setVOILUTRange(activeViewportIndex, 1500, 300);
  //       break;
  //     case 52: //CT BRAIN
  //       setVOILUTRange(activeViewportIndex, 80, 40);
  //       break;
  //     case 53: //CT CHEST
  //       setVOILUTRange(activeViewportIndex, 400, 40);
  //       break;
  //     case 54: //CT LUNGS
  //       setVOILUTRange(activeViewportIndex, 1500, -400);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  useEffect(() => {
    // if (activeTool === DEFAULT_TOOL) {
    //   return;
    // }
    setPreviousActiveTool(activeTool);
    // setActiveTool(DEFAULT_TOOL);
    handleDefaultToolChange();
  }, [activeViewportIndex, activeThumbnailIndex]);

  useEffect(() => {
    if ((viewportIndex === 0 && viewportLoaded) || (hpLoading && viewportLoaded)) {
      setTimeout(async () => {
        setToolOnActiveViewport(
          viewportIndex,
          activeTool,
          previousActiveTool,
          activeViewportIndex
        );
      }, 500); 
    }
  }, [viewportLoaded, hpLoading]);

  const setActive = (updateFromViewportSeriesData=true) => {
    if (isSynchronizedEnabled) {
      enableStackScrollSync(viewportIndex);
    } else {
      disableStackScrollSync();
    }
    setActiveViewportModality(viewportModality);
    changeActiveViewportIndex(viewportIndex);
    if (viewportLoaded) {
      changeActiveThumbnailIndex(
        viewportSeriesData[viewportIndex].thumbnailIndex
      );
      if(updateFromViewportSeriesData) {

        setActiveModality(viewportSeriesData[viewportIndex].modality);
        let studyIdString = viewportSeriesData[viewportIndex].study;
        let studyIdInteger = parseInt(studyIdString, 10);
        setActiveStudyId(studyIdInteger);
      }
    } else {
      changeActiveThumbnailIndex(undefined);
    }

    if(boundingBoxAdding && boundingBoxAdding === "disabled" && activeTool === 'RectangleROI' && editWarning.success){
      console.log("call from here");
      handleRemoveWarning();
    }else{
      setBoundingBoxAdding("disabled");
    }    
  };

  const updateZoomedInViewportState = async () => {
    const viewport = await getViewport(viewportIndex);
    updateViewportProperties(viewportIndex, viewport);
  };

  const initializeAllViewportState = async () => {
    for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
      const viewport = await getViewport(viewportIndex);
      updateViewportProperties(viewportIndex, viewport);
    }
  };

  const showLargeImage = async () => {
    if(viewportLoaded && !isCineEnabled){
      if(!viewportOldState.largeImage){
        await initializeAllViewportState();
      }else{
        await updateZoomedInViewportState();
      }


    const activeViewport = await getViewport(activeViewportIndex);
    updateViewportProperties(activeViewportIndex, activeViewport);
        
      setViewportOldState((prevState) => ({
        ...prevState,
        viewportIndex: viewportIndex,
        // activeImageIndex: currentImage,
        isDoubleClicked: true,
        largeImage: !prevState.largeImage,
      })); 
    }
  };

  useEffect(() => {
    if (viewportOldState.isDoubleClicked && viewportOldState.viewportIndex === viewportIndex) {
      if (viewportOldState.largeImage) {

        const viewportMap = new Map();

        for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
            viewportMap.set(viewportIndex, false);
        }
        
        const allViewportOldStatus = Object.fromEntries(viewportMap);

        setViewportOldState((prevState) => ({
          ...prevState,
          reportMenu: reportMenu,
          seriesMenu: seriesMenu,
          showPathologyOptions: showPathologyOptions,
          viewportRow: viewportRow,
          viewportColumn: viewportColumn,
          isDoubleClicked: true,
          activeViewportIndex: activeViewportIndex,
          activeThumbnailIndex: viewportSeriesData[viewportIndex].thumbnailIndex,
          allViewportOldStatus: allViewportOldStatus,
          loadOldViewportStatus: true,
          viewportSeriesData: viewportSeriesData
        }));

        setReportMenu(false);
        setSeriesMenu(false);
        setShowTopBar(false);
        setShowSharedTopBar(false);
        setShowPathologyOptions(false);
        // setViewportRow(1);
        // setViewportColumn(1);
        setViewerOpacity(0.1);
        setViewportDoubleClickIndex(viewportIndex);
        setViewportDoubleClickIndexConst(viewportIndex);
        
      } else {
        setReportMenu(viewportOldState.reportMenu);
        setSeriesMenu(viewportOldState.seriesMenu);
        setShowTopBar(true);
        setShowSharedTopBar(true);
        setShowPathologyOptions(viewportOldState.showPathologyOptions);
        // setViewportRow(viewportOldState.viewportRow);
        // setViewportColumn(viewportOldState.viewportColumn);
        setViewerOpacity(0.1);
        setViewportOldState((prevState) => ({
          ...prevState,
          isDoubleClicked: false,
        }));
        setViewportDoubleClickIndex(-1);
        setViewportDoubleClickIndexConst(-1);

        setTimeout(async () => {
          await updateZoomedInViewportState();
          await resizeViewport();
        }, 200);
      }
    }
  }, [viewportOldState.largeImage, viewportOldState.viewportIndex]);

  useEffect(() =>{
    if(viewportDoubleClickIndex  === viewportIndex) {
      setTimeout(async () => {
        await resizeViewport();
        setTimeout(async () => {
          await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
          setViewerOpacity(1);
        }, 300);
      }, 500);
    }
  }, [viewportDoubleClickIndex]);

  useEffect(() => {
    const handleDoubleClickReturn = async () => {
      if (viewportOldState && 
        viewportOldState.allViewportOldStatus && 
        !viewportOldState.allViewportOldStatus[viewportIndex] &&
        !viewportOldState.isDoubleClicked) {
        
        setViewportOldState((prevState) => {
          const updatedViewportStatus = { ...prevState.allViewportOldStatus };
          updatedViewportStatus[viewportIndex] = true;
          return {
            ...prevState,
            allViewportOldStatus: updatedViewportStatus,
          };
        });

        setTimeout(async () => {
          await resizeViewport();
          await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
          setViewerOpacity(1);
        }, 500);
      }
    };
    
    handleDoubleClickReturn();
  }, [viewportOldState]);

  useEffect(() => {
    const sbHeight = `${elementRef.current.clientHeight - 23}px`;
    setScrollbarHeight(() => {
      return sbHeight;
    });
  }, [viewportRow, viewportColumn, viewportElements]);

  useEffect(() => {
    if (activeViewportIndex === viewportIndex) {
      changeActiveThumbnailIndex(
        viewportSeriesData[viewportIndex].thumbnailIndex
      );
    }
  }, [viewportSeriesData]);

  const updateOriginalImageState = () => {
    if (originalImageActiveState[activeViewportIndex]) {
      let temp = originalImageActiveState.map((state, index) => {
        if (index === activeViewportIndex) {
          return false;
        } else return state;
      });
      setOriginalImageActiveState(temp);
    }
  };

  const handleDrop = async (e) => {
    if (
      !isSeriesValid(
        viewportSeriesData,
        isReferenceLinesEnabled,
        e.dataTransfer.getData("study"),
        viewportRow,
        viewportColumn
      )
    ) {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("viewer.tools.cannot-load-series");
        return newItem;
      });
      return;
    }

    setViewportLoaderRunning(true);
    const thumbnailIndex = e.dataTransfer.getData("thumbnailIndex");
    changeActiveThumbnailIndex(thumbnailIndex);
    setViewportModality(activeModality);
    setViewportProgressComplete(false);
    setViewportProgress(20);
    const stack = e.dataTransfer.getData("stack");
    const heatmapStack = e.dataTransfer.getData("heatmapStack");
    const outlineStack = e.dataTransfer.getData("outlineStack");
    const originalStack = e.dataTransfer.getData("originalStack");

    changeViewportSeriesData(
      JSON.parse(stack),
      e.dataTransfer.getData("study"),
      e.dataTransfer.getData("studyIdDisplay"),
      e.dataTransfer.getData("series"),
      e.dataTransfer.getData("modality"),
      viewportIndex,
      e.dataTransfer.getData("patientId"),
      e.dataTransfer.getData("patientAge"),
      e.dataTransfer.getData("patientSex"),
      e.dataTransfer.getData("patientName"),
      e.dataTransfer.getData("studyDescription"),
      e.dataTransfer.getData("studyDate"),
      thumbnailIndex,
      JSON.parse(originalStack),
      JSON.parse(heatmapStack),
      JSON.parse(outlineStack),
      e.dataTransfer.getData("orderId")
    );
    
    setOverlayPatientData({
      patientName: e.dataTransfer.getData("stack").patientName,
      patientAge: e.dataTransfer.getData("stack").patientAge,
      patientSex: e.dataTransfer.getData("stack").patientSex,
    });
    setOverlayStudyData({
      studyId: e.dataTransfer.getData("stack").studyId,
      studyDescription: e.dataTransfer.getData("stack").studyDescription,
    });
    if (e.dataTransfer.getData("modality") === "SR") {
      generateSRReport(e.dataTransfer.getData("image"), setSRReport);
      setTimeout(() => {
        setViewportLoaderRunning(false);
        setDragEvent(false);
      }, 1000);
      return;
    }
    setActive(false);
    setViewportProgress(50);
    setThumbnailId(thumbnailIndex);
    setViewportLoaded(true);
    updateOriginalImageState();
    await loadViewport(thumbnailIndex, viewportIndex);
    setViewportProgress(100);
    // setCurrentImage(0);
    setDragEvent(false);
    setViewportLoaderRunning(false);
    if(viewportElement){
      // console.log("---ViewportElement---",viewportElement);
      viewportElement.focus();
      viewportElement.tabIndex = 0;
    }

    // setTimeout(() => {
      resetRotation(viewportIndex);
      resetStackPosition(viewportIndex);
    // }, 200);
  };

  useEffect(() => {
    const updateVOI = (event) => {
      const { range } = event.detail;

      if (!range) {
        return;
      }

      const { lower, upper } = range;
      const { windowWidth, windowCenter } = utilities.windowLevel.toWindowLevel(
        lower,
        upper
      );

      setVOI({
        windowWidth: windowWidth,
        windowCenter: windowCenter,
      });
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(Enums.Events.VOI_MODIFIED, updateVOI);

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.VOI_MODIFIED,
          updateVOI
        );
      };
    }
  }, [viewportElement]);

  useEffect(() => {
    const cameraModifiedLister = async (event) => {
      try {
        const m = await updateOrientationMarkers(
          event,
          "viewport_" + activeViewportIndex
        );
        getInitialZoom(viewportIndex, setScale, event);
        setMarkers(m);
      } catch (error) {
        console.error(error);
        return;
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.CAMERA_MODIFIED,
        cameraModifiedLister
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.CAMERA_MODIFIED,
          cameraModifiedLister
        );
      };
    }
  }, [viewportElement]);

  useEffect(() =>{
    if(activeModality === 'SR'){
      setIsSrSelected(true);
    }
  },[activeModality]);
  
  useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          performResize();
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);

  /*useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          await resetViewPlaneOfCamera(viewportIndex);
          setViewportFocusCalled(false);
          setTimeout(async () => {
            await resetViewPlaneOfCamera(viewportIndex);
            setViewportFocusCalled(false);
          }, 100);
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);*/

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  useEffect(() => {
    const loadSecondTime = async () => {
        if(viewportLoaded && viewportRendered){
          if(!viewportFocusCalled) {
            console.log("load viewport again");
            setViewportFocusCalled(true);

            handleLoadSecondTime();
            
            let activeViewport = null;
            if (isMPRActive) {
              activeViewport = await getMPRViewport(viewportIndex);
            } else {
              activeViewport = await getViewport(viewportIndex);
            }
            activeViewport.resetCamera({
              resetPan: true,
              resetZoom: true,
              resetToCenter: true,
              storeAsInitialCamera: true,
            });
            activeViewport.resize();
            activeViewport.render();
          };
        }
      }

      loadSecondTime();
  },[viewportLoaded, viewportFocusCalled, viewportRendered]);

  useEffect(() => {
    setToolOnActiveViewport(
      viewportIndex,
      activeTool,
      previousActiveTool,
      activeViewportIndex
    );
  }, [activeTool]);

  const onDrag = async () => {
    if (activeTool === StackScrollTool.toolName) {
      setCurrentImage(await getCurrentImage(activeViewportIndex));
    }
  };

  function replaceWithBr() {
    return srReport.replace(/\n/g, "<br />");
  }

  const [impressionRight, setImpressionRight] = useState(10);
  const [impressionBottom, setImpressionBottom] = useState(
    showKeyImageStar ? 75 : 60
  );
  const [impressionTop, setImpressionTop] = useState(0);
  const handleDragStart = () => {
    // if (showCompare) setShowCompare(false);
  };

  const handleDragStop = (event, data) => {
    let { x, y } = data;
    let right = 10 - x;
    let bottom = 20 - y;

    let clientHeight = $("#viewport_" + viewportIndex).height();
    let clientWidth = $("#viewport_" + viewportIndex).width();
    let impressionHeight = clientHeight * 0.4;
    let impressionWidth = clientWidth * 0.4;

    if (right <= impressionWidth) {
      setImpressionRight(right);
    } else {
      setImpressionRight(right - impressionWidth + 10);
    }

    if (bottom + 50 >= impressionHeight) {
      if (showKeyImageStar) {
        setImpressionTop(clientHeight - bottom - 20);
        // setImpressionBottom(bottom - impressionHeight - 25);
        setImpressionBottom(0);
      } else {
        setImpressionTop(clientHeight - bottom - 35);
        // setImpressionBottom(bottom - impressionHeight - 40);
        setImpressionBottom(0);
      }
    } else {
      if (showKeyImageStar) {
        setImpressionTop(0);
        setImpressionBottom(bottom + 55);
      } else {
        setImpressionTop(0);
        setImpressionBottom(bottom + 40);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        impressionRef.current &&
        !impressionRef.current.contains(event.target)
      ) {
        setShowCompare(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  
  // useEffect(() => {
  //   const viewportElement = viewportRef.current;
  //   if (!viewportElement) return;

  //   const handlePointerDown = (event) => {
  //     // console.log("handlePointerDown");
  //     if (event.pointerType === "mouse") { 
  //       isDragging.current = false;

  //       rightClickTimer.current = setTimeout(() => {
  //         rightClickTimer.current = null;
  //       }, rightClickThreshold);
  //     }
  //   };

  //   const handlePointerMove = () => {
  //     // console.log("handlePointerMove");
  //     if (rightClickTimer.current !== null) {
  //       isDragging.current = true;
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   const handlePointerUp = (event) => {
  //     // console.log("handlePointerUp");
  //     if (event.pointerType === "mouse") {
  //       if (rightClickTimer.current !== null && !isDragging.current) {
  //         if(activeTool === "RectangleROI" && disableAddPathology){
  //           handleRemoveWarning();
  //         }
  //       }
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   if(activeTool === "RectangleROI" && disableAddPathology){
  //     viewportElement.addEventListener("pointerdown", handlePointerDown);
  //     viewportElement.addEventListener("pointermove", handlePointerMove);
  //     viewportElement.addEventListener("pointerup", handlePointerUp);
  //   }

  //   return () => {
  //     viewportElement.removeEventListener("pointerdown", handlePointerDown);
  //     viewportElement.removeEventListener("pointermove", handlePointerMove);
  //     viewportElement.removeEventListener("pointerup", handlePointerUp);
  //   };
  // }, [activeTool]);

  function convertToBase64(index, callback) {
    let viewport = document.querySelector(`#viewport_${index}`);
    let cornerstoneCanvas = viewport.querySelector("canvas");
    const svgLayer = document.getElementById("svg-layer-viewport_" + index);

    if (!cornerstoneCanvas || !svgLayer) {
        alert("Canvas or SVG layer not found!");
        return;
    }

    const canvasRect = cornerstoneCanvas.getBoundingClientRect();
    const svgRect = svgLayer.getBoundingClientRect();
  
    const tempCanvas = document.createElement("canvas");
    const ctx = tempCanvas.getContext("2d");
  
    tempCanvas.width = canvasRect.width;
    tempCanvas.height = canvasRect.height;
  
    console.log(`Cornerstone Canvas - Width ${tempCanvas.width} , Height: ${tempCanvas.height}`);
    ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);
  
      // Clone and scale the SVG
      const clonedSvg = svgLayer.cloneNode(true);
      clonedSvg.setAttribute("width", canvasRect.width);
      clonedSvg.setAttribute("height", canvasRect.height);
      clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
  
      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
      const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;
  
      const img = new Image();
      img.crossOrigin = "anonymous";
  
      img.onload = function () {
        const xOffset = svgRect.left - canvasRect.left;
        const yOffset = svgRect.top - canvasRect.top;
  
        ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);
        const finalBase64 = tempCanvas.toDataURL("image/png");
        if (callback) callback(finalBase64);
      };
  
      img.src = svgDataUrl;
  }

  async function convertToBase64WithMasking(index, imageId, callback) {
    let viewport = document.querySelector(`#viewport_${index}`);
    let cornerstoneCanvas = viewport.querySelector("canvas");
    const svgLayer = document.getElementById("svg-layer-viewport_" + index);

    if (!cornerstoneCanvas || !svgLayer) {
        alert("Canvas or SVG layer not found!");
        return;
    }

    const viewportObj = await getViewport(index);
    if (!viewportObj) {
      alert("Viewport object not found!");
      return;
    }
    const frameOfReferenceUID = viewportObj.getFrameOfReferenceUID();
    
    const annotationManager = annotation.state.getAnnotationManager();
    const rectangleROIs = annotationManager.annotations[frameOfReferenceUID]?.RectangleROI || [];

    // Filter only annotations matching the given imageId
    const filteredAnnotations = rectangleROIs.filter(a => a.metadata?.imageId === imageId);

    console.log("Filtered annotations", filteredAnnotations, rectangleROIs, imageId);
    const canvasRect = cornerstoneCanvas.getBoundingClientRect();
    const svgRect = svgLayer.getBoundingClientRect();
  
    const tempCanvas = document.createElement("canvas");
    const ctx = tempCanvas.getContext("2d");
  
    tempCanvas.width = canvasRect.width;
    tempCanvas.height = canvasRect.height;
  
    console.log(`Cornerstone Canvas - Width ${tempCanvas.width} , Height: ${tempCanvas.height}`);
    ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);
  
      // Clone and scale the SVG
      const clonedSvg = svgLayer.cloneNode(true);
      clonedSvg.setAttribute("width", canvasRect.width);
      clonedSvg.setAttribute("height", canvasRect.height);
      clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
  
      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
      const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;
  
      const img = new Image();
      img.crossOrigin = "anonymous";
  
      img.onload = function () {
        const xOffset = svgRect.left - canvasRect.left;
        const yOffset = svgRect.top - canvasRect.top;
  
        ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

        // Draw black filled rectangles for filtered annotations
        filteredAnnotations.forEach(annotation => {
          if (!annotation.data || !annotation.data.handles || !annotation.data.handles.points) {
            console.warn("Invalid annotation data", annotation);
            return;
          }
          const points = annotation.data.handles.points;
          if (points.length < 4) {
            console.warn("Not enough points in annotation", annotation.annotationUID);
            return;
          }

          // points are world coordinates: [x,y,z]
          const worldStart = points[0];
          const worldEnd = points[3];

          // Convert world coords to canvas coords
          const canvasStart = viewportObj.worldToCanvas(worldStart);
          const canvasEnd = viewportObj.worldToCanvas(worldEnd);

          const x = canvasStart[0];
          const y = canvasStart[1];
          const width = canvasEnd[0] - canvasStart[0];
          const height = canvasEnd[1] - canvasStart[1];

          ctx.fillStyle = 'black';
          ctx.fillRect(x, y, width, height);

          console.log(`Masked bounding box drawn for annotation ${annotation.annotationUID}`);
        });

        const finalBase64 = tempCanvas.toDataURL("image/png");
        if (callback) callback(finalBase64);
      };
  
      img.src = svgDataUrl;
  }
  
  async function  handleClippingStudy(index, usgAgentEnabled) {
    setViewportLoaderRunning(true);
    try {
      let seriesId =  viewportSeriesData[index].stack.seriesId;
      let studyIdString = viewportSeriesData[viewportIndex].study;
      let imageId = viewportSeriesData[index].stack.images[currentImage].id;
      
      console.log(`seriesId: ${seriesId} \n studyId ${studyIdString} \n imageId: ${imageId}`);

      convertToBase64WithMasking(index, imageId, async (base64Image) => {
        
            setViewportLoaderRunning(true);
            const result2 = await submitStudyClipping(studyIdString,seriesId, imageId, base64Image);
            console.log("handleClippingStudy request response:", result2);
            if(result2.result == "SUCCESS"){
              setViewportLoaderRunning(false);
              showToastv2(TOAST_TYPE.SUCCESS, t("react-study-clipping.study-clipping-success-msg"));
            }else{
              setViewportLoaderRunning(false);
              showToastv2(TOAST_TYPE.ERROR, t("react-study-clipping.study-clipping-fail-msg"));
            } 
                       
        });
      

      // const result = await submitStudyClipping(studyIdString,seriesId, imageId);
      // console.log("handleClippingStudy request response:", result);
      // if(result.result == "SUCCESS"){
      //   showToastv2(TOAST_TYPE.SUCCESS, t("react-study-clipping.study-clipping-success-msg"));
      // }else{
      //   showToastv2(TOAST_TYPE.ERROR, t("react-study-clipping.study-clipping-fail-msg"));
      // }
    } catch (error) {
      console.error("handleClippingStudy request failed:", error);
      showToastv2(TOAST_TYPE.ERROR, t("react-study-clipping.study-clipping-fail-msg"));
    } finally {
      setViewportLoaderRunning(false);
    }
  }

// Function to copy base64 to clipboard
async function copyToClipboard(index) {
  console.log("Series Data: "+viewportSeriesData[index].stack.seriesId);
  console.log("Image ID:"   + viewportSeriesData[index].stack.images[currentImage].id);
  convertToBase64(index, async (base64Image) => {
      try {

          const response = await fetch(base64Image);
          const blob = await response.blob();
          const item = new ClipboardItem({ "image/png": blob });

          await navigator.clipboard.write([item]);
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-capture-button-text"));
          //alert("Image copied to clipboard!");
      } catch (err) {
          console.error("Failed to copy image:", err);
      }
  });
}



async function handleUploadScDicom(index) {
  setViewportLoaderRunning(true);
  const seriesId = viewportSeriesData[index].stack.seriesId;
  const imageId = viewportSeriesData[index].stack.images[currentImage].id;
  console.log("Series Id: "+seriesId);
  console.log("imageId: "+imageId);
  let viewport = document.querySelector(`#viewport_${index}`);
  let cornerstoneCanvas = viewport.querySelector("canvas");
  const svgLayer = document.getElementById("svg-layer-viewport_" + index);

  if (!cornerstoneCanvas || !svgLayer) {
      alert("Canvas or SVG layer not found!");
      return;
  }

  // Clone the SVG to prevent modifications in the viewer
  const clonedSvg = svgLayer.cloneNode(true);

  // Get actual displayed size of canvas & SVG
  const canvasRect = cornerstoneCanvas.getBoundingClientRect();
  const svgRect = svgLayer.getBoundingClientRect();

  // Ensure SVG matches the actual canvas dimensions
  clonedSvg.setAttribute("width", canvasRect.width);
  clonedSvg.setAttribute("height", canvasRect.height);
  clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);

  // Convert SVG to base64
  const svgData = new XMLSerializer().serializeToString(clonedSvg);
  const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
  const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

  // Create a new canvas for merging images
  const tempCanvas = document.createElement("canvas");
  const ctx = tempCanvas.getContext("2d");

  // Use the ACTUAL displayed dimensions (not internal ones)
  tempCanvas.width = canvasRect.width;
  tempCanvas.height = canvasRect.height;

  // Draw the DICOM canvas first
  ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

  // Load and draw the SVG overlay
  const img = new Image();
  img.crossOrigin = "anonymous";

  img.onload = async function () {
      // Correcting offset positioning
      const xOffset = svgRect.left - canvasRect.left;
      const yOffset = svgRect.top - canvasRect.top;
      ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

      // Convert final merged canvas to Base64
      const base64Data = tempCanvas.toDataURL("image/png").replace(/^data:image\/\w+;base64,/, "");

      // Upload the Base64 image
      try {
          const result = await uploadScDicom(base64Data,imageId);
          setViewportLoaderRunning(false);
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-clipboard-copy-button-text"));
          console.log("Upload successful:", result);
      } catch (error) {
          console.error("Upload failed:", error);
      }
  };

  img.src = svgDataUrl;
}



 return (
    <>
      <div
        className="viewport-parent-container h100 w100"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          className="viewport-container h100 w100"
          style={{
            position: viewportModality === "SR" ? "absolute" : "static",
            opacity: viewportModality === "SR" ? 0 : 1,
            pointerEvents: viewportModality === "SR" ? "none" : "auto",
            zIndex: viewportModality === "SR" ? -1 : "auto", // optional, prevents overlap
          }}
          
        >
          {/* {contextMenuOpen.open && (
            <ContextMenu
              mouseEvt={contextMenuOpen.mouseEvt}
              data={contextMenuOpen.data}
            />
          )} */}
  <div>

            </div>
          <div
            id={`viewport_${viewportIndex}`}
            className="cursor-pointer viewport-box h100 w100"
            //onKeyDown={onKeyPress}
            onClick={setActive}
            onDoubleClick={showLargeImage}
            // ref={viewportRef}
          >
           
            <div
              ref={elementRef}
              id="viewportEntry"
              className="h100 w100"
              style={{
                backgroundColor: 'black'
              }}
              onDrop={handleDrop}
              onDragOver={(e) => {
                e.preventDefault();
              }}
            ></div>
            {viewportLoaderRunning && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                }}
              >
                <Spinner size={15} />
              </div>
            )}

            <ImageScrollbar
              max={imageCount}
              // value={
              //   isSynchronizedEnabled ? synchronizedCurrentImage : currentImage
              // }
              value={currentImage}
              onChange={onChange}
              //onKeyPress={onKeyPress}
              height={scrollbarHeight}
              elementRef={elementRef}
            />
            {showOverlay && viewportLoaded && (
              <>
                {process.env.REACT_APP_VDC_PLATFORM === "false" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <MobileOverlay
                      viewportData={viewportSeriesData[viewportIndex]}
                    />
                  )}
                {process.env.REACT_APP_VDC_PLATFORM === "true" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <>
                      <VDCMobileDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        isVDCMobileViewer={true}
                      />
                    </>
                  )}
                {!isMobile && viewportRow <= 2 && viewportColumn <= 2 && (
                  <PatientDetails
                    viewportData={viewportSeriesData[viewportIndex]}
                    showForceReinference={showForceReinference}
                    forceReinference={forceReinference}
                    reportDoneStatusState={reportDoneStatusState}
                  />
                )}
                {!isMobile && viewportRow <= 2 && viewportColumn <= 2 && (
                  <StudyDetails
                    viewportData={viewportSeriesData[viewportIndex]}
                    viewportIndex={viewportIndex}
                  />
                )}
                      
                <SCDICOMDetails
                    viewportData={viewportSeriesData[viewportIndex]}
                    viewportIndex={viewportIndex} 
                    copyToClipboard={copyToClipboard}
                    handleUploadScDicom={handleUploadScDicom}
                  />

                  <StudyClippingDetails
                    viewportIndex={viewportIndex} 
                    handleClippingStudy={handleClippingStudy}
                    loaderRunning={viewportLoaderRunning}
                  />
                  {usgAgentEnabled !== 0 && !isWordFilePath && reportDoneStatusState < 2 && reportingDoctorName !== null && reportingDoctorName == username &&
                    <StudyMaskingProfile
                      viewportIndex={viewportIndex}
                      viewportData={viewportSeriesData[viewportIndex]}
                      currentImage={currentImage} 
                      loaderRunning={viewportLoaderRunning}
                      setLoaderRunning={setViewportLoaderRunning}
                    />
                  }
                <SeriesDetails
                  viewportData={viewportSeriesData[viewportIndex]}
                  // currentImage={
                  //   isSynchronizedEnabled
                  //     ? synchronizedCurrentImage
                  //     : currentImage
                  // }
                  currentImage={currentImage}
                  totalImage={imageCount}
                />
                {showCompare && isCompareActive && (
                  <div
                    // ref={impressionRef}
                    className="viewer-tool-more-dropdown"
                    style={{
                      position: "absolute",
                      height: "40%",
                      maxHeight: "40%",
                      width: "40%",
                      padding: "10px 10px 0px 10px",
                      borderRadius: "10px",
                      bottom: `${
                        impressionBottom === 0
                          ? "unset"
                          : impressionBottom + "px"
                      }`,
                      right: `${impressionRight}px`,
                      top: `${
                        impressionTop === 0 ? "unset" : impressionTop + "px"
                      }`,
                    }}
                  >
                    <div
                      id={`impression-text-viewport-${viewportIndex}`}
                      className="modal-scroll"
                      style={{
                        height:
                          viewportRow === 1
                            ? "90%"
                            : viewportRow === 2
                            ? "80%"
                            : "75%",
                        overflowY: "auto",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          impressions[
                            "study_" + viewportSeriesData[viewportIndex].study
                          ]?.impressionText,
                      }}
                    >
                      {/* {
                        impressions[
                          "study_" + viewportSeriesData[viewportIndex].study
                        ]?.impressionText
                      } */}
                    </div>
                    <div
                      className="cursor-pointer"
                      style={{
                        height:
                          viewportRow === 1
                            ? "10%"
                            : viewportRow === 2
                            ? "20%"
                            : "25%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        var r = document.createRange();
                        r.selectNode(
                          document.getElementById(
                            `impression-text-viewport-${viewportIndex}`
                          )
                        );
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(r);
                        document.execCommand("copy");
                        window.getSelection().removeAllRanges();
                        // let copyText = document.getElementById(
                        //   `impression-text-viewport-${viewportIndex}`
                        // );
                        // navigator.clipboard.writeText(copyText.innerHTML);
                        showToastv2(TOAST_TYPE.SUCCESS, "Copied to clipboard!");
                      }}
                    >
                      <Copy />
                    </div>
                  </div>
                )}
                {isCompareActive && (
                  <Draggable
                    bounds="parent"
                    onStop={handleDragStop}
                    onStart={handleDragStart}
                    offsetParent={viewportElement}
                  >
                    <div
                      // ref={impressionRef}
                      style={{
                        position: "absolute",
                        bottom: showKeyImageStar ? "35px" : "20px",
                        right: "10px",
                      }}
                      onClick={() => {
                        setShowCompare((prev) => !prev);
                      }}
                      onMouseEnter={() => setImpressionHover(true)}
                      onMouseLeave={() => setImpressionHover(false)}
                    >
                      <Impression
                        color={
                          showCompare || impressionHover
                            ? theme.palette.activeTool
                            : theme.palette.inactiveTool
                        }
                      />
                    </div>
                  </Draggable>
                )}
              {  <DICOMDetails
                  voi={voi}
                  scale={scale}
                  showKeyImageStar={showKeyImageStar}
                />  }
                <OrientationMarkers markers={markers} />
                {editWarning.show &&
                  viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MarkWarning
                      success={editWarning.success}
                      handleRemoveWarning={isCreatingMaskingProfile ? handleRemoveMaskWarning : handleRemoveWarning}
                      pathalogyName={editWarning.name}
                      backgroundColor={editWarning.color}
                      id={editWarning.id}
                    />
                  )}
                  {
                   enableLlmReport && isChestXrayStudy(studyModality, studyDescription) && viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MaskImage
                      show={maskingConfirm.show}
                      success={maskingConfirm.success}
                      backgroundColor={maskingConfirm.color}
                      maskImages = {maskImages}
                      currentImage= {currentImage}
                      viewportIndex = {viewportIndex}
                      activeThumbnailIndex= {viewportSeriesData[viewportIndex].thumbnailIndex}
                      id={maskingConfirm.id}
                    />
                  )}
              </>
            )}
            {isCineEnabled && activeViewportIndex === viewportIndex && (
              <>
                <div className="viewport-cine-container">
                  <div className="viewport-cine-box">
                    <span
                      className="viewport-cine-button"
                      style={{ marginRight: "10px" }}
                      onClick={() =>
                        setViewportLevelCINEEnabled(!viewportLevelCINEEnabled)
                      }
                    >
                      {viewportLevelCINEEnabled ? (
                        <CINEPauseSmall />
                      ) : (
                        <CINEPlaySmall />
                      )}
                    </span>
                    <span
                      className={`viewport-cine-button ${
                        cINEFramesPerSecond === 1
                          ? "viewport-cine-button-disabled"
                          : ""
                      }`}
                      onClick={() => {
                        if (cINEFramesPerSecond !== 1) {
                          setCINEFramesPerSecond(cINEFramesPerSecond - 1);
                        }
                      }}
                    >
                      {" "}
                      <CINEMinus />{" "}
                    </span>
                    <span style={{color:"#ffffff"}}> {cINEFramesPerSecond} </span>
                    {/* <span className="viewport-cine-framepersecond-button">{cINEFramesPerSecond}</span> */}
                    <span
                      className="viewport-cine-button"
                      onClick={() =>
                        setCINEFramesPerSecond(cINEFramesPerSecond + 1)
                      }
                    >
                      {" "}
                      <CINEPlus />{" "}
                    </span>
                  </div>
                </div>
              </>
            )}
            {!viewportLoaderRunning && !viewportLoaded && (
              <>
                <div
                  className="viewport-empty-message h100 w100"
                  onDrop={handleDrop}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span>{t("studyviewer.empty-viewport-message")}</span>
                </div>
              </>
            )}
          </div>
        </div>
        {viewportModality === "SR" && (
          <div
            className="viewport-sr-container h100 w100"
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onClick={setActive}
          >
            <div className="viewer-modal-scroll viewport-sr">
              <span
                dangerouslySetInnerHTML={{ __html: replaceWithBr() }}
              ></span>
            </div>
            {viewportLoaderRunning && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                }}
              >
                <Spinner size={15} />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(Viewport);
